import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20abstract%20composition%20of%20soft%20floating%20fabric%20swatches%20in%20warm%20peach%20coral%20and%20dusty%20terracotta%20tones%20against%20a%20gentle%20gradient%20background%20from%20cream%20to%20light%20sand%2C%20ethereal%20gossamer%20texture%2C%20airy%20negative%20space%20in%20upper%20half%2C%20editorial%20art%20photography%2C%20no%20text%2C%20weightless%20elegant%20aesthetic&width=1600&height=900&seq=hero-bg-main-v2-t&orientation=landscape"
          alt="AllChinaBuy Spreadsheet hero background"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center pt-16 pb-10">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-4xl mb-5 drop-shadow-lg">
          {t("home:heroTitle", "Find The Best AllChinaBuy Spreadsheet In One Place")}
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mb-8 leading-relaxed drop-shadow-md">
          {t("home:heroSubtitle", "Discover trusted spreadsheet links, verified sellers, buying guides, and the latest product finds updated weekly.")}
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-white shadow-lg text-foreground-900 text-sm font-semibold hover:bg-white/95 transition-all whitespace-nowrap cursor-pointer"
          >
            {t("common:allchinabuySheet", "AllChinaBuy Sheet")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer shadow-lg"
          >
            {t("common:buyItNow", "Buy It Now")}
          </a>
        </div>

        <div className="relative w-full max-w-sm">
          <select
            value={selectedCategory}
            onChange={handleCategoryChange}
            className="w-full appearance-none bg-white border border-white/30 rounded-xl px-5 py-3.5 pr-10 text-sm text-foreground-800 font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400/50 transition-all shadow-md"
          >
            <option value="">{t("home:heroDropdownLabel", "Browse by Category")}</option>
            {categories.map((cat) => (
              <option key={cat.slug} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-foreground-500"></i>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {[
            t("home:trustBadge1", "10,000+ Product Links"),
            t("home:trustBadge2", "Weekly Updates"),
            t("home:trustBadge3", "Trusted Sellers"),
            t("home:trustBadge4", "Buying Safety Guides"),
            t("home:trustBadge5", "Free Spreadsheet Access"),
          ].map((badge, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs md:text-sm font-medium whitespace-nowrap"
            >
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}